<template>
    <v-layout v-if="$can('manage', 'model')">
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Model'|translate }}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="addDialog=true;editedItem=null" :disabled="!$can('update', 'Model')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Model'|translate }}
                    </v-btn>
                    <model-record-dialog v-model="dialog" :item="editedItem"
                                         v-on:doreload="refresh"></model-record-dialog>
                    <v-dialog v-model="addDialog" max-width="800" persistent>
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{'Add Model'|translate}}
                            </v-card-title>
                            <v-container fluid>
                                <v-layout wrap align-center justify-center >
                                    <v-flex xs3 v-for="possibleType in possibleTypes">
                                        <v-hover v-slot:default="{ hover }">
                                            <v-card
                                                height="120px"
                                                class="pa-2 ma-2 cursor-as-pointer"
                                                @click="addModel(possibleType)"
                                                :elevation="hover ? 12 : 2"
                                                :class="{ 'on-hover': hover }">
                                                <v-icon x-large class="ma-2 layout justify-center">fa-brain</v-icon>
                                                <h3 class="mx-4 layout justify-center">{{possibleType|translate}}</h3>
                                            </v-card>
                                        </v-hover>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="addDialog=false">{{'Cancel'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-actions>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="points"
                        :items-per-page="25"
                        :search="search2"
                        :rows-per-page-items="[25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.model_id }}</td>
                            <td class="text-xs-left">{{ props.item.model_name }}</td>
                            <td class="text-xs-left">
                                {{ props.item.model_type }}
                            </td>
                            <td class="text-xs-left">{{ props.item.model_status }}</td>
                            <td class="text-xs-left">{{ props.item.topic }}</td>
                            <td class="text-xs-left">{{ props.item.model_active }}</td>
                            <td class="text-xs-left">{{ props.item.equipment_name }}</td>
                            <td class="text-xs-left">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Model')"
                                    @click="$can('update', 'Model') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Model')"
                                    @click="$can('update', 'Model') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getModel, deleteModel} from '../helper'
import ModelRecordDialog from '../components/model/ModelRecordDialog'

export default {
    name: 'Model',
    components: {ModelRecordDialog},
    data() {
        return {
            dialog: false,
            headers: [

                {
                    text: this.$options.filters.translate('Model ID'),
                    align: 'left',
                    sortable: true,
                    value: 'model_id'
                },
                {text: this.$options.filters.translate('Model Name'), value: 'model_name'},
                {text: this.$options.filters.translate('Model Type'), value: 'model_type'},
                {text: this.$options.filters.translate('Status'), value: 'model_status'},
                {text: this.$options.filters.translate('Topic'), value: 'topic'},
                {text: this.$options.filters.translate('Active'), value: 'model_active'},
                {text: this.$options.filters.translate('Equipment Name'), value: 'equipment_name'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            points: [],
            editedIndex: -1,
            editedItem: {},
            possibleTypes:['anomaly', 'supervised', 'power','cooling load'],
            addDialog:false,
            search: '',
            search2: '',
            timeout:null,
        }
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    mounted() {
        this.initialize()
    },
    methods: {
        addModel(type){
            this.addDialog=false;
            this.editedItem={
                'model_id': null,
                'model_type': type,
                'model_name': '',
                'model_status': 'pending',
                'model_active': false,
                'title': '',
                'desc': '',
                'topic': 'default',
                'severity': '',
                'relevant_variables': '',
                'recommended_actions': '',
                'on': true,
                'equipment_name': '',
                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                'model_date_from': null,
                'model_date_to': null,
                'model_meta': '',
            };
            this.dialog=true;
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        initialize() {
            this.refresh()
        },
        editItem(item) {
            this.editedIndex = this.points.indexOf(item)
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },
        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteModel({
                    'model_id': item.model_id
                })
                await this.refresh()
            }
        },
        async refresh() {
            let df = await getModel({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            this.points = df['result']
        }
    }
}
</script>

<style scoped>

</style>
